import { render, staticRenderFns } from "./IconQuoteSent.vue?vue&type=template&id=4bb2b5aa&scoped=true&"
import script from "./IconQuoteSent.vue?vue&type=script&lang=ts&"
export * from "./IconQuoteSent.vue?vue&type=script&lang=ts&"
import style0 from "./IconQuoteSent.vue?vue&type=style&index=0&id=4bb2b5aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2b5aa",
  null
  
)

export default component.exports